import { CreditCard, Users } from 'lucide-react'
import { NavLink, Outlet } from 'react-router-dom'

import { PageHeader } from '@/components/page-header'
import { cn } from '@/lib/utils'

const TABS = [
	{ to: '/app/settings/members', label: 'Members', icon: Users },
	{ to: '/app/settings/billing', label: 'Billing', icon: CreditCard },
] as const

export function SettingsLayout() {
	return (
		<div className="space-y-6">
			<PageHeader
				title="Settings"
				description="Manage your organization, members, and billing."
			/>
			<nav className="flex gap-1 border-b">
				{TABS.map((tab) => (
					<NavLink
						key={tab.to}
						to={tab.to}
						className={({ isActive }) =>
							cn(
								'flex items-center gap-2 border-b-2 px-3 py-2 text-sm font-medium transition-colors -mb-px',
								isActive
									? 'border-primary text-foreground'
									: 'border-transparent text-muted-foreground hover:text-foreground',
							)
						}
					>
						<tab.icon className="size-4" />
						{tab.label}
					</NavLink>
				))}
			</nav>
			<Outlet />
		</div>
	)
}
